var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    fillRule: "nonzero",
    stroke: "#32325D",
    strokeWidth: 0.2,
    d: "M14.191 10.119l-1.36-.967c.228-.84.227-1.727-.004-2.566l1.365-.956-1.09-1.885-1.518.694c-.614-.618-1.382-1.06-2.224-1.28L9.215 1.5h-2.18l-.144 1.66c-.843.22-1.611.662-2.224 1.28l-1.519-.695-1.089 1.886 1.365.955c-.231.84-.233 1.726-.004 2.566l-1.361.967 1.089 1.877 1.519-.696c.613.618 1.381 1.06 2.224 1.28l.144 1.66h2.18l.145-1.66c.842-.22 1.61-.662 2.223-1.28l1.519.695 1.09-1.875-.001-.001zM9.629.739c.2 0 .366.157.375.358l.133 1.526c.555.211 1.072.51 1.532.883l1.388-.647c.178-.092.397-.027.496.146l1.504 2.603c.1.173.047.395-.121.503l-1.256.879c.096.598.093 1.195.001 1.77l1.255.877c.169.108.222.33.121.504l-1.504 2.592c-.1.174-.318.238-.496.147l-1.388-.648c-.451.368-.966.668-1.532.885l-.133 1.526c-.01.2-.175.357-.375.357H6.62c-.2 0-.365-.157-.375-.357l-.133-1.526c-.555-.212-1.072-.51-1.533-.885l-1.387.648c-.178.092-.397.028-.497-.146L1.193 10.14c-.1-.173-.047-.395.121-.503l1.255-.879c-.094-.586-.094-1.183 0-1.769l-1.254-.878c-.168-.108-.221-.33-.121-.502l1.501-2.604c.1-.174.32-.238.497-.146l1.388.647c.46-.374.978-.672 1.532-.883l.133-1.527c.01-.2.175-.357.375-.357h3.008zM8.125 5.25c1.45 0 2.625 1.175 2.625 2.625S9.575 10.5 8.125 10.5 5.5 9.325 5.5 7.875 6.675 5.25 8.125 5.25zm0 .75C7.089 6 6.25 6.84 6.25 7.875c0 1.036.84 1.875 1.875 1.875C9.161 9.75 10 8.91 10 7.875 10 6.839 9.16 6 8.125 6h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.c6de7d2f74e3521b93b1265ec26fdeaa.svg";
export { ForwardRef as ReactComponent };